import React from "react";
import LookupsCard from "./lookupsCard";

const Lookups = () => {
  return (
    <div className="col-10 mt-4">
      <LookupsCard name="item" />
      <LookupsCard name="measurement" />
      <LookupsCard name="statistic" />
      {/* <LookupsCard name="period" /> */}
    </div>
  );
};

export default Lookups;
